import { observable, action, computed, makeObservable } from 'mobx';
import agent from '../lib/agent';

class Store {
  project = null;
  tasks = new Map();

  loadTasks = async (projectId, buildingId) => {
    this.tasks = new Map();
    const response = await agent.Task.getProjectTasks(projectId, buildingId);
    this.tasks = new Map(
      response.data.data.map(task => {
        return [task.id, task];
      })
    );
  };

  loadTask = async id => {
    try {
      const { data } = await agent.Task.get(id);
      if (data.ok) {
        this.tasks.set(data.data.id, data.data);
        return this.tasks.get(data.data.id);
      }
    } catch (e) {
      return null;
    }
  };

  get = id => {
    return this.tasks.get(id);
  };

  constructor() {
    makeObservable(this, {
      project: observable,
      tasks: observable,
      loadTasks: action,
      loadTask: action,
      get: action,
      total: computed,
      create: action,
      updateStatus: action,
      update: action,
      deleteTask: action
    });
  }

  get total() {
    return this.tasks.size;
  }

  create = async taskData => {
    const postParams = {
      ...taskData,
      users: taskData.users.map(u => u.id)
    };

    const { data } = await agent.Task.create(postParams);
    if (data.ok) {
      this.tasks.set(data.data.id, data.data);
      return data.data;
    }
    return null;
  };

  updateStatus = async taskData => {
    const task = this.tasks.get(taskData.id);
    this.tasks.set(taskData.id, taskData);
    await this.update(taskData, task);
  };

  update = async (taskId, taskData) => {
    const tasks = new Map(this.tasks);
    const task = tasks.get(taskId);
    const newTask = {
      ...task,
      status: taskData.status
    };

    if (taskData.status !== task.status) {
      tasks.set(taskId, newTask);
      this.tasks = tasks;
    }

    try {
      const { data } = await agent.Task.update(taskId, taskData);
      tasks.set(data.data.id, data.data);
    } catch (err) {
      tasks.set(task.id, task);
    }

    this.tasks = tasks;
  };

  deleteTask = async id => {
    const { data } = await agent.Task.delete(id);
    if (data.ok) {
      this.tasks.delete(id);
      return data.data;
    }
    return null;
  };
}

const store = new Store();
export default store;
